<div *ngIf="showInstallPrompt"
     class="fixed bottom-0 left-0 right-0 z-[9999] bg-black/50 p-4 install-prompt-animate sm:p-2">
  <div class="relative bg-white dark:bg-gray-800 rounded-xl px-6 py-6 max-w-sm mx-auto shadow-lg sm:px-4 sm:py-5">

    <!-- Botão fechar -->
    <button
      (click)="closePrompt()"
      aria-label="Fechar"
      class="absolute top-3 right-3 text-2xl leading-none cursor-pointer text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors px-2 py-1 bg-transparent border-none"
    >✕</button>

    <!-- Ícone -->
    <div class="text-5xl text-center mb-4">📱</div>

    <!-- Título -->
    <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-100 text-center mb-2">Instalar Professores</h3>

    <!-- Descrição -->
    <p class="text-gray-600 dark:text-gray-300 text-center leading-relaxed mb-5">
      Adicione o app à tela inicial para acesso rápido e uso offline
    </p>

    <!-- Botões -->
    <div class="flex flex-col sm:flex-row gap-3 justify-center">
      <button
        (click)="closePrompt()"
        class="px-6 py-3 rounded-lg text-base font-medium cursor-pointer transition-all bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 border-none"
      >Agora não</button>
      <button
        (click)="installApp()"
        class="px-6 py-3 rounded-lg text-base font-medium cursor-pointer transition-all bg-blue-700 dark:bg-blue-600 text-white hover:bg-blue-800 dark:hover:bg-blue-700 hover:-translate-y-px hover:shadow-md border-none"
      >Instalar</button>
    </div>

  </div>
</div>
